/* eslint-disable @typescript-eslint/naming-convention */
export enum ContentType {
  BANNER = 'banner',
  BANNER_TILE = 'bannertile',
  CONTENT_PAGE = 'contentpage',
  CONTENT_FOLDER = 'contentfolder',
  CONTENT_LINK = 'contentlink',
}
